import { watch } from 'vue'
import { useAuthStore } from '~~/stores/authStore'
import { useAnalytics } from '~~/app/composables/useAnalytics'

/**
 * Identyfikacja użytkownika dla warstwy danych (Segmentify / GA4).
 *
 * Wypycha `user_data` i ustawia window.__user: dla zalogowanego z profilem
 * (id, email, imię, nazwisko, newsletter), dla gościa z `user: null` +
 * `logged_in: false`. Jedna instancja (plugin) → brak duplikatów mimo wielu
 * wywołań useAuth w komponentach (dodatkowa asekuracja: dedup po sygnaturze
 * w useAnalytics.identifyUser / identifyGuest).
 *
 * Czeka na `authStore.isResolved` — dopiero zakończone GET /api/store/account/info
 * (profil albo 401) rozstrzyga, czy sesja jest anonimowa. Bez tego warunku każde
 * wejście zaczynało się ogłoszeniem gościa, także dla zalogowanych.
 *
 * Źródło danych: authStore.currentUser, zasilany z GET /api/store/account/info
 * (login POST zwraca tylko potwierdzenie — profil dociągany osobno). Dlatego
 * imię/nazwisko/newsletter są dostępne mimo że sam request logowania ich nie ma.
 */
export default defineNuxtPlugin(() => {
  const authStore = useAuthStore()
  const analytics = useAnalytics()

  watch(
    () => ({ resolved: authStore.isResolved, user: authStore.currentUser }),
    ({ resolved, user }) => {
      analytics.syncIdentity({ resolved, user })
    },
    { immediate: true, deep: true },
  )
})
